import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  userPool: CognitoUserPool;
  cognitoUser: CognitoUser = {} as CognitoUser;
  
  accountDetailsFormGroup = this._formBuilder.group({
    emailCtrl: ['', [Validators.required, Validators.email]],
  });
  verificationFormGroup = this._formBuilder.group({
    codeCtrl: ['', Validators.required],
    newPasswordCtrl: ['', Validators.required],
  });

  constructor(private _formBuilder: FormBuilder, private router: Router) {
    let poolData = {
      UserPoolId: environment.cognitoUserPoolId, // Your user pool id here
      ClientId: environment.cognitoAppClientId // Your client id here
    };

    this.userPool = new CognitoUserPool(poolData);
  }

  onVerify(stepper: MatStepper) {
    let userData = { Username: this.accountDetailsFormGroup.controls["emailCtrl"].value as string, Pool: this.userPool };
    this.cognitoUser = new CognitoUser(userData);
    this.cognitoUser.forgotPassword({
      onSuccess: (data) => {
        stepper.next();
      },
      onFailure: (err) => {
        alert(err.message || JSON.stringify(err));
      }
    });
  }

  onComplete(stepper: MatStepper) {
    this.cognitoUser.confirmPassword(
      this.verificationFormGroup.controls["codeCtrl"].value as string, 
      this.verificationFormGroup.controls["newPasswordCtrl"].value as string, {
        onSuccess: (data) => {
          stepper.next();
        },
        onFailure: (err) => {
          alert(err.message || JSON.stringify(err));
        }
      });
  }

  onDone(){
    this.router.navigate(["dashboard"]);
  }
}
